import { STANDARD_INSURANCE_DOMAIN_PREFIX } from "../../enums/prefix";

export function isStandardInurance(domain: string): boolean {
    return domain.includes(STANDARD_INSURANCE_DOMAIN_PREFIX)
}